import axios from 'axios'
/**
 * 上传路径
 * @returns {Stirng}
 */
export function uploadPath () {
  return '/prod-api/system/file/upload';
}

//获取字典-单个
export function getDicts (dictType) {
  return axios.get(`/system/dict/data/type/${dictType}`)
}
//获取字典-组合type
export function getDictGroups (data) {
  return axios.get('/system/dict/data/selectDictDataByTypes', { params: data })
}
export function saveMenu (data) {
  return axios.post(`/system/menu/save`, data)
}
export function updateMenu (data) {
  return axios.post(`/system/menu/update`, data)
}
export function deleteMenuData (ids) {
  return axios.delete(`/system/menu/${ids}`)
}
export function getmenuList (data) {
  return axios.get(`/system/menu/list`, { params: data })
}
export function getUserInfo (data) {
  return axios.get(`/system/user/getInfo`, data)
}
//用户列表
export function getUserList (data) {
  return axios.get(`/system/user/list`, { params: data })
}
//新增修改用户
export function modifyAccount (data, action) {
  return axios.post(`/system/user/${action}`, data)
}
//修改密码
export function modifyPassword (data) {
  return axios.post(`/system/user/controlPassword`, data)
}
//删除用户
export function delUsers (ids) {
  return axios.delete(`/system/user/${ids}`)
}
//部门列表
export function getDeptList (data) {
  console.log(data, '部门')
  return axios.get(`/system/dept/list`, { params: data })
}
//新增修改部门
export function modifyDept (data, action) {
  return axios.post(`/system/dept/${action}`, data)
}
//部门详情
export function getDeptData (id) {
  return axios.get(`/system/dept/${id}`)
}
//删除部门
export function delDepts (ids) {
  return axios.delete(`/system/dept/${ids}`)
}
//角色列表
export function getRoleList (data) {
  console.log(data, '角色')
  return axios.get(`/system/role/list`, { params: data })
}
//新增角色
export function saveRole (data) {
  return axios.post(`/system/role/save`, data)
}
export function detailRole (id) {
  return axios.get(`/system/role/${id}`)
}
export function delrole (ids) {
  return axios.delete(`/system/role/${ids}`)
}
export function updaterole (data) {
  return axios.post(`/system/role/update`, data)
}
export function dictType (data) {
  return axios.post(`/system/dict/type`, data)
}
export function dictTypeList (data) {
  return axios.get(`/system/dict/type/list`, { params: data })
}
export function deleteDictType (data) {
  return axios.delete(`/system/dict/type/${data}`)
}
export function editDictType (data) {
  return axios.put(`/system/dict/type`, data)
}
export function dictDataList (data) {
  return axios.get(`/system/dict/data/list`, { params: data })
}
export function addDictDataList (data) {
  return axios.post(`/system/dict/data`, data)
}
export function editDictData (data) {
  return axios.put(`/system/dict/data`, data)
}
export function deleteDictData (data) {
  return axios.delete(`/system/dict/data/${data}`)
}

export function userByRoleList (data) {
  return axios.get(`/system/user/selectUserInfosByRoleName`, { params: data })
}
export function modifyUserStatus (data) {
  return axios.post(`/system/user/modifyStatus`, data)
}